import { useParams, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { usePlatformOrganisation } from '../hooks/usePlatformOrganisation';
import { OrgOverviewTab } from '../components/organisms/OrgOverviewTab';
import { OrgFeaturesTab } from '../components/organisms/OrgFeaturesTab';
import { PageBreadcrumb } from '../../../shared/components/layout/PageBreadcrumb';
import { PageHeader } from '../../../shared/components/layout/PageHeader';
import { ChipTabs } from '../../../shared/components/ui/ChipTabs';
import { Routes } from '../../../routes';

const DETAIL_TABS = [
  { label: 'Overview', value: 'overview' },
  { label: 'Features', value: 'features' },
] as const;

const PlatformOrganisationDetailPage = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'features' ? 'features' : 'overview';

  const { data } = usePlatformOrganisation(orgId ?? '');
  const organisationName = data?.name ?? '';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2, pb: 1 }}>
          <PageBreadcrumb
            segments={[
              { label: 'Organisations', to: Routes.platform.organisations },
              { label: organisationName },
            ]}
          />
        </Box>

        <PageHeader title={organisationName} />

        <Box sx={{ px: { xs: 2, sm: 3 }, pb: 1 }}>
          <ChipTabs
            tabs={[...DETAIL_TABS]}
            value={tab}
            onChange={v => setSearchParams({ tab: v }, { replace: true })}
            data-testid="org-detail-tabs"
          />
        </Box>

        {tab === 'features' ? (
          <OrgFeaturesTab orgId={orgId ?? ''} />
        ) : (
          <OrgOverviewTab orgId={orgId ?? ''} />
        )}
      </Box>
    </Box>
  );
};

export default PlatformOrganisationDetailPage;
